;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('UseTermsService', useTermsService)

  /* @ngInject */
  function useTermsService (ConnectorWebService, CONSTANTS, Utils) {
    var service = {
      getUseTerms,
      setUseTerms,
      getUseTermsById,
      updateUseTerms,
      deleteUseTerm,
      getCountTemplatesByUseTerms,
      setArtUseTerms
    }
    return service

    function getUseTerms ({ top, skip, search } = {}) {
      let url = CONSTANTS.URL_USE_TERMS

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (search) {
        url = Utils.fnAddQueryToUrl(url, {
          search
        })
      }

      return ConnectorWebService.get(url)
    }

    function getUseTermsById (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USE_TERMS_BY_ID, [id])
      return ConnectorWebService.get(url)
    }

    function setUseTerms (useTerms) {
      return ConnectorWebService.post(CONSTANTS.URL_USE_TERMS, useTerms)
    }

    function updateUseTerms (id, useTerms) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USE_TERMS_BY_ID, [id])
      return ConnectorWebService.put(url, { ...useTerms })
    }

    function deleteUseTerm (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USE_TERMS_BY_ID, [id])
      return ConnectorWebService.fnDelete(url)
    }

    function getCountTemplatesByUseTerms (id) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USE_TERMS_COUNT_IN_ARTS, [id])
      return ConnectorWebService.get(url)
    }

    function setArtUseTerms (useTerms) {
      return ConnectorWebService.post(CONSTANTS.URL_ART_USE_TERMS_LOG, useTerms)
    }
  }
})()
